import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import 'antd/dist/reset.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //         <App />
  // </React.StrictMode>

    <React.Fragment>
        <App/>
    </React.Fragment>
);
reportWebVitals();
